import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function UserAdd({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M18 17.75H15.5M16.75 16.5V19M10 15H7C4.79 15 3 16.79 3 19V20M16.75 13.5C15.6228 13.5 14.5418 13.9478 13.7448 14.7448C12.9478 15.5418 12.5 16.6228 12.5 17.75C12.5 18.8772 12.9478 19.9582 13.7448 20.7552C14.5418 21.5522 15.6228 22 16.75 22C17.8772 22 18.9582 21.5522 19.7552 20.7552C20.5522 19.9582 21 18.8772 21 17.75C21 16.6228 20.5522 15.5418 19.7552 14.7448C18.9582 13.9478 17.8772 13.5 16.75 13.5ZM11 3C9.93913 3 8.92172 3.42143 8.17157 4.17157C7.42143 4.92172 7 5.93913 7 7C7 8.06087 7.42143 9.07828 8.17157 9.82843C8.92172 10.5786 9.93913 11 11 11C12.0609 11 13.0783 10.5786 13.8284 9.82843C14.5786 9.07828 15 8.06087 15 7C15 5.93913 14.5786 4.92172 13.8284 4.17157C13.0783 3.42143 12.0609 3 11 3Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default UserAdd;